import axios from '../axios/axios';
import {
  EXERCISE_DATA_REQUEST,
  EXERCISE_DATA_SUCCESS,
  EXERCISE_DATA_FAIL,
} from '../constants/exerciseConstants';

export const exerciseAction = () => async (dispatch) => {
  try {
    dispatch({ type: EXERCISE_DATA_REQUEST });
    const { data } = await axios.post('/rpiq-form-fetch', {
      section: 'f1v1s8',
      form_id: localStorage.getItem('formId'),
    });

    dispatch({
      type: EXERCISE_DATA_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (
      error?.response?.status === 401 ||
      error?.response?.detail === 'Not authenticated'
    ) {
      window.location.replace('/');
    }
    dispatch({
      type: EXERCISE_DATA_FAIL,
      payload: error,
    });
  }
};
